/** The Audit log's When filter in the URL: `from` / `to` carry a relative token
 *  (`now-15m`, which the backend resolves per request — the window keeps moving) or a
 *  local wall clock ('yyyy-MM-ddTHH:mm:ss'; older links stop at minutes). */
import { format } from 'date-fns';

import {
  boundToIso,
  formatRelative,
  isRelative,
  parseRelative,
  type TimeBound,
} from '@/components/TimeWindowPicker';

/** A minute-precision To covers its whole minute, so it reads as that minute's last second. */
export const rangeBound = (v: string, end = false): TimeBound | null => {
  if (!v) return null;
  const rel = parseRelative(v);
  if (rel) return rel;
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return null;
  return end && /T\d{2}:\d{2}$/.test(v) ? new Date(d.getTime() + 59_000) : d;
};
export const rangeParam = (b: TimeBound | null): string | null => {
  if (!b) return null;
  if (isRelative(b)) return formatRelative(b);
  return Number.isNaN(b.getTime()) ? null : format(b, "yyyy-MM-dd'T'HH:mm:ss");
};
/** The API takes the token as is, or the instant to the second (a To covers its second). */
export const rangeToApi = (end: boolean) => (v: string) => {
  const b = rangeBound(v, end);
  return b ? boundToIso(b) : undefined;
};
